import "../../stylesheets/App.css";
import "../../stylesheets/Game.css";
import React, { useState, useEffect } from "react";
import LoaderGame from "./LoaderGame.js";
import PopupError from "./PopupError.js";

function Game(props) {
  let [loadingSaveBet, setLoadingSaveBet] = useState(false);
  let [score1, setScore1] = useState(props.bet ? props.bet.score1 : "");
  let [score2, setScore2] = useState(props.bet ? props.bet.score2 : "");
  let [initialScore1, setInitialScore1] = useState(props.bet ? props.bet.score1 : "");
  let [initialScore2, setInitialScore2] = useState(props.bet ? props.bet.score2 : "");
  let [popupBet, setPopupBet] = useState(false);
  let [openErrorPopup, setOpenErrorPopup] = useState(false);

  let [orderedTeams, setOrderedTeams] = useState([]);
  let [background1, setBackground1] = useState({});
  let [background2, setBackground2] = useState({});

  // --- CIERRE: 15 min antes del inicio del partido ---
  const gameDate = new Date(props.data.date);
  const deadline = new Date(gameDate.getTime() - 15 * 60 * 1000);
  const isClosed = new Date() >= deadline;

  useEffect(() => {
    const teams = props.data.teams || [];
    if (teams.length === 2) {
      const sorted = [...teams].sort((a, b) => a.GameTeam.order - b.GameTeam.order);
      setOrderedTeams(sorted);
      setBackground1({ backgroundImage: "url(" + sorted[0].image_url + ")" });
      setBackground2({ backgroundImage: "url(" + sorted[1].image_url + ")" });

      // Evitar crash si aún no existe el botón en el DOM
      const btn = document.getElementById("save-btn-" + props.data.idGame);
      if (btn) btn.disabled = true;

      if (props.bet) {
        setScore1(props.bet.score1);
        setScore2(props.bet.score2);
        setInitialScore1(props.bet.score1);
        setInitialScore2(props.bet.score2);
      }
    }
  }, [props.data.teams, props.bet, props.data.idGame]);

  const saveBet = async () => {
    // Si está cerrado, ni intentamos (igual el back lo bloquea, pero evitamos request)
    if (isClosed) return;

    setLoadingSaveBet(true);
    let item = {
      score1,
      score2,
      idUser: JSON.parse(localStorage.getItem("user-info")).idUser,
      idGame: props.data.idGame,
    };

    let result;
    if (props.bet) {
      // modifico apuesta existente
      result = await fetch(
        process.env.REACT_APP_API_BASE_URL + "/bets/update/" + props.bet.idBet,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(item),
        }
      );
    } else {
      // creo nueva apuesta
      result = await fetch(process.env.REACT_APP_API_BASE_URL + "/bets/add", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(item),
      });
    }

    result = await result.json();
    if (result.status == 200) {
      setLoadingSaveBet(false);
      setPopupBet(true);
      setTimeout(() => setPopupBet(false), 2000);
      updateInitialScore1();
      updateInitialScore2();
    } else if (result.status == 201) {
      setLoadingSaveBet(false);
      setOpenErrorPopup(true);
    } else {
      setLoadingSaveBet(false);
    }
  };

  useEffect(() => {
    updateSaveButton();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [score1, score2, initialScore1, initialScore2, isClosed]);

  const updateScore1 = (e) => {
    const cleaned = e.currentTarget.value.replace(/[^0-9]/g, "");
    setScore1(cleaned);
  };

  const updateScore2 = (e) => {
    const cleaned = e.currentTarget.value.replace(/[^0-9]/g, "");
    setScore2(cleaned);
  };

  const updateInitialScore1 = () => {
    setInitialScore1(score1);
  };

  const updateInitialScore2 = () => {
    setInitialScore2(score2);
  };

  const updateSaveButton = () => {
    let btn = document.getElementById("save-btn-" + props.data.idGame);
    if (!btn) return;

    // Si está cerrado, siempre deshabilitado
    if (isClosed) {
      btn.style.backgroundColor = "var(--color-gris-claro)";
      btn.disabled = true;
      return;
    }

    if (
      score1 !== "" &&
      score2 !== "" &&
      (score1 != initialScore1 || score2 != initialScore2)
    ) {
      btn.style.backgroundColor = "var(--color-verde)";
      btn.disabled = false;
    } else {
      btn.style.backgroundColor = "var(--color-gris-claro)";
      btn.disabled = true;
    }
  };

  // Formato fecha/hora
  let fechaOriginal = new Date(props.data.date);

  let dia = String(fechaOriginal.getDate()).padStart(2, "0");
  let mes = String(fechaOriginal.getMonth() + 1).padStart(2, "0");
  let anio = fechaOriginal.getFullYear();
  let fechaFormateada = `${dia}/${mes}/${anio}`;

  let horas = String(fechaOriginal.getHours()).padStart(2, "0");
  let minutos = String(fechaOriginal.getMinutes()).padStart(2, "0");
  let horaFormateada = `${horas}:${minutos} hs`;

  return (
    <>
      <div className={`game-container ${isClosed ? "game-passed" : ""}`}>
        <div className="team-container">
          <div className="team-img" style={background1} />
          <h4>{orderedTeams[0]?.name}</h4>
          <div className="input-container">
            <input
              type="text"
              inputMode="numeric"
              pattern="\d{1,2}"
              maxLength={2}
              className="score-imput"
              placeholder="-"
              value={score1}
              onChange={updateScore1}
              disabled={isClosed}
            />
          </div>
        </div>

        <div className="date-container">
          <p>{props.data.stage.name}</p>
          <p>{fechaFormateada}</p>
          <>{horaFormateada}</>

          <div className="save-container">
            <button
              className="save-btn"
              id={"save-btn-" + props.data.idGame}
              onClick={saveBet}
              disabled={isClosed}
            >
              {isClosed ? "Apuesta cerrada" : "Guardar"}
            </button>
          </div>

          {isClosed ? <div className="status-finished"></div> : ""}
        </div>

        <div className="team-container">
          <div className="team-img" style={background2} />
          <h4>{orderedTeams[1]?.name}</h4>
          <div className="input-container">
            <input
              type="text"
              inputMode="numeric"
              pattern="\d{1,2}"
              maxLength={2}
              className="score-imput"
              placeholder="-"
              value={score2}
              onChange={updateScore2}
              disabled={isClosed}
            />
          </div>
        </div>

        {popupBet ? <div className="popup-bet">Pronóstico realizado con éxito</div> : ""}
        {loadingSaveBet ? <LoaderGame /> : ""}

        {openErrorPopup ? (
          <PopupError
            description="Ya es demasiado tarde para pronosticar en este partido. Lo siento!"
            setOpenErrorPopup={setOpenErrorPopup}
            setRefresh={props.setRefresh}
          />
        ) : (
          ""
        )}
      </div>
    </>
  );
}

export default Game;
